import CampaignDetailRanking from './CampaignDetailRanking';

export default CampaignDetailRanking;
